<template>
  <div class="user-layout">
    <transparent-box>

      <div class="profile-component-top">
        <div class="profile-component-avatar">
          <div class="col-md-12 col-12 mb-10">
            <image-component
                :value.sync="user?.profile.image"
            ></image-component>
          </div>
        </div>
        <div class="profile-component-general">
          <default-title h_tag="h3">
            {{$t('user.general_info')}}
          </default-title>
          <ValidationObserver v-slot="{ invalid, passes }" ref="form">
          <form v-if="user"
                class="position-relative"
                @submit.prevent="passes(updateGeneral)">
            <div class="row">
            <div class="row-column col-md-6 mt-20">
              <default-title h_tag="h4">
                {{$t('user.edit_general_info')}}
              </default-title>
              <div class="col-md-12 col-12 mb-10 mt-10">
                <ValidationProvider rules="required" vid="name" name="name" v-slot="{ errors }">
                <default-input
                    :label="$t('inputs.name')"
                    v-model="user.name"
                />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="col-md-12 col-12 mb-10">
                <ValidationProvider rules="required" vid="surname" name="surname" v-slot="{ errors }">
                <default-input
                    :label="$t('inputs.surname')"
                    v-model="user.surname"
                />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="col-md-12 col-12 mb-10">
                <ValidationProvider rules="required" vid="email" name="email" v-slot="{ errors }">
                <default-input
                    :label="$t('inputs.email')"
                    type="email"
                    v-model="user.email"
                />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="row-column col-md-6 mt-20">
              <default-title h_tag="h4">
                {{ $t('user.change_password') }}
              </default-title>
              <template v-if="route_is_profile">
                <div class="col-md-12 col-12 mb-10 mt-10">
                  <default-input
                      :label="$t('inputs.old_password')"
                      type="password"
                      v-model="user.password"
                  />
                </div>
                <div class="col-md-12 col-12 mb-10">
                  <ValidationProvider rules="required_if:user.password" vid="user.new_password" name="user.new_password" v-slot="{ errors }">
                  <default-input
                      :label="$t('inputs.new_password')"
                      type="password"
                      v-model="user.new_password"
                  />
                    <span>{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 col-12 mb-10">
                  <ValidationProvider rules="required_if:user.new_password" vid="user.password_confirm" name="user.password_confirm" v-slot="{ errors }">
                  <default-input
                      :label="$t('inputs.new_password_confirm')"
                      type="password"
                      v-model="user.password_confirm"
                  />
                  <span>{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </template>

            </div>
            </div>
            <div class="row">
              <div class="ml-auto col-md-3 col-6">
                <button
                    :disabled:="data_sync"
                    class="w-100 profile-component-success"
                    type="submit">
                  {{ $t('inputs.save') }}
                </button>
              </div>
            </div>
          </form>
          </ValidationObserver>
        </div>
      </div>

      <div class="profile-component-middle">
        <div class="profile-component-actions">
          <default-title h_tag="h3">
            {{ $t('user.my_actions') }}
          </default-title>
          <div class="profile-component-actions-list">
            <div class="profile-component-actions-list-actions mb-10 mt-10">
              <div class="row align-center">
                <p class="mb-0">{{ $t('user.daily_report') }}</p>
              </div>

              <div class="profile-component-actions-list-actions-right">
                <template v-if="filledDailyReport === false">
                  <p class="mb-0 mr-10 alert-danger">{{$t('user.not_filled')}}</p>
                  <router-link-to
                      class=""
                      :route_name="routes_names.dashboard">
                    <button type="button" class="w-20 profile-component-small">{{$t('inputs.set_up')}}</button>
                  </router-link-to>
                </template>
                <template v-else>
                  <p class="mb-0 mr-10 alert-success">{{$t('user.filled')}}</p>
                </template>
              </div>
            </div>

          </div>
        </div>
        <div class="profile-component-profile">
          <default-title h_tag="h3">
            {{ $t('user.profile_info') }}
          </default-title>
          <ValidationObserver v-slot="{ invalid, passes }" ref="form">
          <form v-if="user"
                class="position-relative"
                @submit.prevent="passes(updateProfile)">

            <div class="row mt-20">
              <div class="col-md-6 col-12 mb-10">
                <ValidationProvider :rules="{ regex: /^\+?[0-9]{10,12}$/ }" vid="user.profile.phone" name="user.profile.phone" v-slot="{ errors }">
                <default-input
                    :label="$t('inputs.phone')"
                    type="text"
                    placeholder="+38012345678"
                    size="13"
                    minlength="9"
                    maxlength="14"
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    v-model="user.profile.phone"
                />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
                <default-input
                    :label="$t('inputs.address')"
                    v-model="user.profile.address"
                />
              </div>
              <div class="col-md-6 col-12 mb-10">
                <ValidationProvider rules="required" vid="passport_details" name="passport_details" v-slot="{ errors }">
                  <default-input
                      :label="$t('user.passport_details') + '*'"
                      v-model="user?.profile.passport_details"
                  />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="row">
                  <div class="col-md-6 col-12 mb-10">
                    <ValidationProvider vid="gender" name="gender" v-slot="{ errors }">
                      <default-select
                          :placeholder="$t('inputs.gender')"
                          :selected_val="user.profile.gender"
                          display_item_api_key="title"
                          :list_outer="genders"
                          @change="changeGender"
                      />
                      <span>{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6 col-12 mb-10">
                    <ValidationProvider vid="contract_type" name="contract_type" v-slot="{ errors }">
                      <default-select
                          :placeholder="$t('inputs.contract_type')"
                          :selected_val="user.profile.contract_type"
                          display_item_api_key="title"
                          :list_outer="contract_types"
                          @change="changeContractType"
                      />
                      <span>{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

              </div>

            </div>

            <div class="row">
              <div class="ml-auto col-md-3 col-6">
                <button
                    :disabled:="data_sync"
                    class="w-100 profile-component-success"
                    type="submit">
                  {{ $t('inputs.save') }}
                </button>
              </div>
            </div>
          </form>
          </ValidationObserver>
        </div>
      </div>

      <div class="profile-component-bottom">
        <div class="profile-component-reports">
          <default-title h_tag="h3">
            {{ $t('user.generate_reports') }}
          </default-title>
          <div class="profile-component-reports-list mt-20">
            <div class="profile-component-actions-list-header">
              <h5 class="">{{ $t('user.daily_report') }}</h5>
            </div>
            <div class="profile-component-actions-list-actions mb-10 mt-20">
              <div class="profile-component-actions-list-actions-right">
                <template >
                  <div class="col-md-12 col-12 mb-10">
                    <label class="profile-component-date-input">
                        <span title="Manager" class="default-input__label">
                          {{ $t('inputs.select_date') }}
                        </span>

                      <input type="date" class="mt-1" @click="clearDailyReport()"
                             v-model="daily_report_date">
                    </label>
                  </div>
                </template>
              </div>
              <div class="profile-component-actions-list-actions-right">
                <button
                    v-if="!generated_daily_report" type="button" class="w-20 profile-component-small"
                    @click="generateDailyReport()"
                >
                  {{ $t('inputs.generate') }}
                </button>
                <button v-else type="button" class="w-20 profile-component-small">
                  <span @click="generateDownloadLink(generated_daily_report, 'daily')" >
                    {{ $t('inputs.download') }}
                  </span>
                </button>
              </div>
            </div>

            <div class="profile-component-actions-list-header">
              <h5 class="">{{ $t('user.site_report') }}</h5>
            </div>
            <div class="profile-component-actions-list-actions mb-10 mt-20">
              <div class="profile-component-actions-list-actions-right">
                <template >
                  <div class="col-md-12 col-12 mb-10">
                    <label class="profile-component-date-input">
                        <span title="Manager" class="default-input__label">
                          {{ $t('inputs.start_date') }}
                        </span>

                      <input type="date" class="" @click="clearTimesheetReport()"
                             v-model="report_start_date">
                    </label>
                    <label class="profile-component-date-input">
                        <span title="Manager" class="default-input__label">
                          {{ $t('inputs.end_date') }}
                        </span>

                      <input type="date" class="" @click="clearTimesheetReport()"
                             v-model="report_end_date">
                    </label>
                  </div>
                </template>
              </div>
              <div class="profile-component-actions-list-actions-right">
                <button
                    v-if="!generated_timesheet_report" type="button" class="w-20 profile-component-small"
                    @click="generateTimesheetPlan()"
                >
                  {{ $t('inputs.generate') }}
                </button>
                <button v-else type="button" class="w-20 profile-component-small">
                  <span @click="generateDownloadLink(generated_timesheet_report, 'timesheet')" >
                    {{ $t('inputs.download') }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="profile-component-belts" v-if="user?.beltBenefit">
          <default-title h_tag="h3">
            {{$t('user.my_benefits')}}
          </default-title>
          <div class="row">
            <div class="row mt-20">
              <div class="col-md-12 col-12 mb-10">
                <default-title h_tag="h4" class="mb-10">{{ $t('user.package') }}</default-title>
                <default-title h_tag="h6">{{ user.beltBenefit.package.title }}</default-title>
                <p>{{ user.beltBenefit.package.description }}</p>
              </div>
              <div class="col-md-12 col-12 mb-10">
                <default-title h_tag="h4" class="mb-10">{{ $t('user.benefit_type') }}</default-title>
                <default-title h_tag="h6">{{ user.beltBenefit.title }}</default-title>
                <p>{{ user.beltBenefit.description }}</p>
              </div>
              <div class="col-md-6 col-12 mb-10">
                <default-input
                    :label="$t('inputs.benefit_start_date')"
                    :value="user.benefit_start_date"
                    :disabled="true"
                ></default-input>
              </div>
              <div class="col-md-6 col-12 mb-10">
                <default-input
                    :label="$t('inputs.benefit_end_date')"
                    :value="user.benefit_end_date"
                    :disabled="true"
                ></default-input>
              </div>
            </div>
          </div>
        </div>
      </div>

    </transparent-box>
  </div>
</template>

<script>

import {axiosProfile, axiosUser, axiosUsers} from "../../../helpers/axios_requests";
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import Switcher from "../../small_components/Switcher.vue";
import {mapActions, mapGetters} from "vuex";
import {NEW_USER} from "../../../helpers/new_objects";
import {STATUS_ERROR} from "../../../store/modules/notifiocation";
import DefaultButton from "../../small_components/DefaultButton.vue";
import BadgeBlock from "../../slots/BadgeBlock.vue";
import DefaultTitle from "../../small_components/DefaultTitle.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import DefaultSelect from "../../small_components/DefaultSelect.vue";
import ImageComponent from "../../parts/ProfileImageComponent.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import TransparentBox from "../../slots/TransparentBlock.vue";
import {ROUTES_NAMES as routes_names} from "../../../router";
import {ValidationProvider, extend, ValidationObserver} from "vee-validate";
import { regex, required, required_if } from 'vee-validate/dist/rules';
import { FORMAT_ERROR_MESSAGE } from '../../../helpers/validation_error_message';

extend('regex', {
  ...regex,
  message: 'This field must be in format: +38012345678'
});
extend('required', {
  ...required,
  message: 'This field is required'
});
extend('required_if', {
  ...required_if,
  message: 'This field is required'
});

export default {
  name: 'ProfileLayout',
  mixins: [routes_mixin],
  components: {
    TransparentBox,
    DefaultBox,
    ImageComponent,
    DefaultSelect,
    DefaultInput,
    DefaultTitle,
    BadgeBlock,
    DefaultButton,
    RouterLinkTo,
    Switcher,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    routes_names() {
      return routes_names
    },
    ...mapGetters([
      'getUser',
      'getUserRoleIsAdmin',
    ]),
    get_id() {
      return Number(this.getUser.id)
    },
    route_is_profile() {
      return this.$route.name === this.route_names.profile
    },
    get_locale_title() {
      if (!this.menu || !this.menu.locales) return ''
      return this.menu.locales.find(el => el.locale === this.mainLocale).title || ''
    },
    get_seo_shown() {
      return !this.menu.type_id || ![4, 5].includes(this.menu.type_id)
    },
    active() {
      return [
        {id: 0, title: 'Banned'},
        {id: 1, title: 'Active'},
      ]
    },
    genders() {
      return [
        {id: 0, title: 'M'},
        {id: 1, title: 'F'},
      ]
    },
    contract_types() {
      return [
        {id: 0, title: 'PE'},
        {id: 1, title: 'Employment'},
      ]
    },
    user_active() {
      return this.active.find(el => this.user.active === el.id)
    }
  },
  data() {
    return {
      user: null,
      roles: [],
      data_sync: false,
      filledDailyReport: false,
      generatedDailyReport: false,
      daily_report_date: null,
      generated_daily_report: false,
      generated_timesheet_report: false,
      report_start_date: null,
      report_end_date: null,
    }
  },
  beforeMount() {
    this.fetchUser(this.get_id)
    this.checkDailyReport()
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    fetchUser(id) {
      if (!id) {
        id = this.get_id;
        return
      }
      axiosUsers.get(id)
          .then(r => {
            if (r.data.profile === null) {
              r.data.profile = {};
            }

            this.$set(this, 'user', r.data)
          })
          .catch(e => {
          })
    },
    updateGeneral() {
      this.data_sync = true
      axiosProfile.updateGeneral(this.user)
          .then(r => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.actionPushNotification({message: 'Saved'})
            if (this.get_id === Number(r.data.id)) return
          })
          .catch(e => {
            this.actionPushNotification({message: 'Error', status: STATUS_ERROR})
          })
          .finally(() => {
            this.data_sync = false
          })
    },
    updateProfile() {
      this.data_sync = true
      axiosProfile.updateProfile(this.user.profile)
          .then(r => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.actionPushNotification({message: 'Saved'})
            if (this.get_id === Number(r.data.id)) return
          })
          .catch(e => {
            this.actionPushNotification({message: 'Error', status: STATUS_ERROR})
          })
          .finally(() => {
            this.data_sync = false
          })
    },
    changeContractType({title}) {
      this.user.profile.contract_type = title
    },
    changeGender({title}) {
      this.user.profile.gender = title
    },
    checkDailyReport() {
      this.data_sync = true
      axiosUser.fetchDailyReport()
          .then(({data}) => {
            if (!data.today_report) return
            this.filledDailyReport = true
          })
          .finally(() => {
            this.data_sync = false
          })
    },
    generateDailyReport() {
      axiosProfile.generateDailyReport({date: this.daily_report_date})
          .then(r => {
            this.generated_daily_report = r.data.filename;
      })
    },
    generateTimesheetPlan() {
      axiosProfile.generateTimesheetPlan({
        start_date: this.report_start_date,
        end_date: this.report_end_date
      })
          .then(r => {
            this.generated_timesheet_report = r.data.filename;
          })
    },
    generateDownloadLink(report, type) {
      const url = window.location.origin + '/uploads/reports/' + this.user.id + '/' + report
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', report) //or any other extension
      document.body.appendChild(link)
      link.click()
      this.deleteReport(report)
      if (type === 'daily') {
        this.clearDailyReport();
      } if (type === 'timesheet') {
        this.clearTimesheetReport();
      }
    },
    generateTimesheetDownloadLink() {
      return window.location.origin + '/uploads/reports/' + this.user.id + '/' + this.generated_timesheet_report;
    },
    deleteReport(name) {
      axiosProfile.deleteReport({filename: name})
          .then(r => {
            console.log(r.data)
          });
    },
    clearDailyReport() {
      this.generated_daily_report = false;
    },
    clearTimesheetReport() {
      this.generated_timesheet_report = false;
    }
  },
}
</script>
